export const mapAccessTierNames = (access, tiers, isNewPostAccess) => {
    if (!tiers)
        return;
    if (isNewPostAccess) {
        if (access.type === 'Public')
            return 'Public (everyone)';
        if (access.type === 'MembersOnly')
            return 'Members only';
        if (access.type === 'FreeMembers')
            return 'Free accounts only';
        if (access.type === 'FreeAndPaidMembers')
            return 'Members & free accounts';
    }
    else {
        if (access.type === 'Public')
            return 'Everyone';
        if (access.type === 'MembersOnly')
            return 'All members';
    }
    const selectedTiers = access.tiers?.map(({ id }) => tiers?.find((tier) => tier.id === id));
    return selectedTiers?.map((tier) => tier?.name).join(', ');
};
